
    <template>
        <main id="main" class="main-site">
            <div class="container">
                <div class="wrap-breadcrumb">
                    <ul>
                        <li class="item-link">
                            <router-link to="/loja" class="fa fa-home"></router-link>
                        </li>
                        <li class="item-link">
                            <span>Fale Conosco</span>
                        </li>
                    </ul>
                </div>
                <div class="main-content-area">
                    <div class="row">
                        <div class="col-xs-12">
                            <h3 class="box-title first">Fale Conosco</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">A ALDO é DISTRIBUIDORA de soluções de TI, energia solar, segurança & monitoramento e comercializa exclusivamente produtos e serviços para atacadistas, varejistas, revendedores, integradores e fabricantes. A ALDO não vende diretamente para o consumidor final, seja ele jurídico ou físico.</div>
                    </div>
                    <div class="row alert alert-info wrapper-aldo-liga">
                        <div class="col-md-2 aldo-liga">
                            <img src="/assets/images/logo-aldo-crazy-phone.png">
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <form @submit.prevent="callToMe"
                                      action="#"
                                      method="get"
                                      class="frmcallToMe"
                                      name="frm-billing">
                                    <div class="col-md-12 col-text">
                                        <h4>FALE COM A ALDO</h4>
                                        <p>
                                            <!-- <strong>Como funciona:</strong> informe seu telefone abaixo e receba em instantes a ligação de um de nossos atendentes. -->
                                            Selecione um de nossos atendentes:
                                        </p>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <!-- <div class="col-md-4">
                                          <FormHelper
                                            :inputVar="this.formCalltoMe.telefone"
                                            :form="this.formCalltoMe"
                                            label="Seu telefone"
                                            placeholder="(99) 99999-9999"
                                            mask="(##) #####-####"
                                          ></FormHelper>
                                        </div> -->
                                            <div class="col-md-6">
                                                <FormHelper :inputVar="this.formCalltoMe.atendente"
                                                            :options="atendentesOptions"
                                                            :form="this.formCalltoMe"
                                                            type="select"
                                                            label="- Selecione -"></FormHelper>
                                            </div>
                                            <!-- <div class="col-md-2 wrap-butons-line2" style="padding-top:24px;">
                                          <button class="btn primary-button" @click="callToMe">
                                            <i class="fa fa-phone"></i> Ligar
                                          </button>
                                        </div> -->
                                        </div>
                                    </div>
                                </form>
                                <div class="col-md-12" hidden id="divContato">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="">Entre em contato:</label>
                                        </div>
                                        <div class="col-md-4">
                                            <span style="font-size: 20px;"><i class="fa fa-phone" aria-hidden="true"></i></span>
                                            <label style="padding-left: 9px;">(44) 3261-{{ formCalltoMe.ramal }} </label>
                                        </div>
                                        <div class="col-md-8">
                                            <span style="font-size: 20px;"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                                            <label style="padding-left: 9px"> {{ formCalltoMe.skype }}@aldo.com.br </label>
                                        </div>
                                        <div class="col-md-8">                                            
                                            <span style="font-size: 20px;"><i class="fa fa-whatsapp" aria-hidden="true"></i></span>
                                            <label style="padding-left: 9px"><a href="https://api.whatsapp.com/send?phone=554432612000"> (44) 3261-2000</a></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="contact-box contact-info">
                                <h2 class="box-title">Nossos dados para contato</h2>
                                <div class="wrap-icon-box">
                                    <div class="icon-box-item">
                                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                                        <div class="right-info">
                                            <b>Endereço</b>
                                            <p>
                                                Av. Advogado Horácio Raccanello Filho, 1836
                                                <br>Maringá – PR - CEP 87.045-237
                                            </p>
                                        </div>
                                    </div>
                                    <div class="icon-box-item">
                                        <i class="fa fa-envelope" aria-hidden="true"></i>
                                        <div class="right-info">
                                            <b>Email</b>
                                            <p>
                                                <a href="mailtocartas@aldo.com.br">cartas@aldo.com.br</a>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="icon-box-item">
                                        <i class="fa fa-phone" aria-hidden="true"></i>
                                        <div class="right-info">
                                            <b>Telefone</b>
                                            <p>
                                                <a href="tel:+554432612000">(44) 3261-2000</a>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="icon-box-item">
                                        <i class="fa fa-whatsapp" aria-hidden="true"></i>
                                        <div class="right-info">
                                            <b>WhatsApp</b>
                                            <p>
                                                <a href="https://api.whatsapp.com/send?phone=554432612000">(44) 3261-2000</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <form @submit.prevent="contactUs"
                                  action="#"
                                  method="get"
                                  class="frmContacUs"
                                  name="frm-billing">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h2 class="box-title">Envie uma mensagem</h2>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="this.frmContacUs.nome"
                                                    :form="this.frmContacUs"
                                                    label="Nome"
                                                    placeholder="Nome"></FormHelper>
                                    </div>
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="this.frmContacUs.empresa"
                                                    :form="this.frmContacUs"
                                                    label="Empresa"
                                                    placeholder="Empresa"></FormHelper>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="this.frmContacUs.cnpj"
                                                    :form="this.frmContacUs"
                                                    label="CNPJ"
                                                    placeholder="00.000.000/0000-00"
                                                    mask="##.###.###/####-##"></FormHelper>
                                    </div>
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="frmContacUs.clienteAldo"
                                                    :form="frmContacUs"
                                                    :options="yesOrNoOptions()"
                                                    type="radio"
                                                    label="Cliente Aldo">
                                        </FormHelper>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="this.frmContacUs.telefone"
                                                    :form="this.frmContacUs"
                                                    label="Telefone"
                                                    placeholder="(99) 99999-9999"
                                                    mask="(##) #####-####"></FormHelper>
                                    </div>
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="this.frmContacUs.email"
                                                    :form="this.frmContacUs"
                                                    label="Email"
                                                    placeholder="E-Mail"></FormHelper>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="this.frmContacUs.setor"
                                                    :form="this.frmContacUs"
                                                    label="Setor"
                                                    placeholder="Selecione um setor"
                                                    :options="getSetores()"
                                                    type="select"></FormHelper>
                                    </div>
                                    <div class="col-md-6">
                                        <FormHelper :inputVar="this.frmContacUs.assunto"
                                                    :form="this.frmContacUs"
                                                    label="Assunto"
                                                    placeholder="Assunto"></FormHelper>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <FormHelper :inputVar="this.frmContacUs.mensagem"
                                                    :form="this.frmContacUs"
                                                    label="Mensagem"
                                                    type="textarea"
                                                    placeholder="Mensagem"></FormHelper>
                                    </div>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-md-10 text-right">
                                    <div class="g-recaptcha" data-sitekey="6LcpQhcTAAAAAB-QnUnNKlJPkEDRTp17DGgvCL7n"></div>
                                </div>
                                <div class="col-md-2 text-right">
                                    <button @click="enviarEmail" class="btn primary-button">
                                      <i class="fa fa-send" id="btnEnviar"></i> Enviar
                                    </button>
                                </div> -->
                                    <div runat="server" class="col-sm-10" id="divRecaptcha">
                                        <div class="g-recaptcha" data-sitekey="6LcpQhcTAAAAAB-QnUnNKlJPkEDRTp17DGgvCL7n"></div>
                                        <br />
                                        <button @click="enviarEmail" aria-labe="Enviar" class="btn primary-button">
                                            <i class="fa fa-send" id="btnEnviar"></i> Enviar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </template>
    
<script>
    import FormHelper from "./partials/FormHelper.vue";

    export default {
        name: "ContactUs",
        props: {
            msg: String
        },
        components: {
            FormHelper
        },
        mounted() {
            this.getAttend();
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
            document.head.appendChild(recaptchaScript)
        },
        data() {
            return {
                atendentesList: [],
                atendentesOptions: [],
                formCalltoMe: {
                    attemptSubmit: false,
                    telefone: new this.formInput(true),
                    atendente: new this.formInput(true),
                    ramal: '',
                    skype: ''
                },
                frmContacUs: {
                    attemptSubmit: false,
                    nome: new this.formInput(true),
                    empresa: new this.formInput(true),
                    cnpj: new this.formInput(true),
                    clienteAldo: new this.formInput(true),
                    telefone: new this.formInput(true),
                    email: new this.formInput(true),
                    setor: new this.formInput(true),
                    assunto: new this.formInput(true),
                    mensagem: new this.formInput(true)
                }
            };
        },
        watch: {
            "formCalltoMe.atendente.value": function (value) {
                let item = this.atendentesList.filter(c => c.usrcodigo == value.code)[0]

                this.formCalltoMe.ramal = item.usrramal;
                this.formCalltoMe.skype = item.usrnome.toLowerCase()

                $("#divContato").removeAttr('hidden')
            }
        },
        methods: {
            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    // Status verifica se o input é obrigatório e possui valor, e retorna verdadeiro ou falso
                    // Para que o usuário seja barrado em caso de um submit sem dados
                    status: !(this.required && this.value === ""),
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },
            callToMe: function () {
                this.formCalltoMe.attemptSubmit = true;
                var numero = this.formCalltoMe.telefone.value.replace(/\D/g, '');
                var ramal = this.formCalltoMe.ramal;
                if ((numero == "") || (numero.length < 10)) {
                    swal({
                        title: "Aviso",
                        text: "Informe o número de telefone corretamente",
                        icon: "warning",
                        button: "OK"
                    })
                }
                else {
                    swal({
                        title: "Solicitação enviada",
                        text: "Aguarde alguns segundos para receber nossa ligação.",
                        icon: "success",
                        button: "OK"
                    })
                }

                //http://192.168.0.32/ http://201.22.95.191 */
                $.ajax({
                    type: "GET",
                    url: "https://10.32.94.2/pbxip/api/index.php?action=dial&request=number&src=" + ramal + "&dst=" + numero + "&key=API-11624404260173E65",
                    dataType: "text",
                    success: () => {
                        // swal({
                        //   title: "Solicitação enviada",
                        //   text: "Aguarde alguns segundos para receber nossa ligação.",
                        //   icon: "success",
                        //   button: "OK"
                        // })
                    }
                });
            },
            contactUs: function () {
                this.frmContacUs.attemptSubmit = true;
            },
            getAttend: function () {
                var xhr = new XMLHttpRequest();
                xhr.onload = () => {
                    if (xhr.status == 200) {
                        if (xhr.responseText != "" && xhr.responseText != null) {
                            let json = JSON.parse(xhr.responseText)
                            json.forEach(element => {
                                let itemlist = {}
                                itemlist.usrcodigo = element.UsrCodigo;
                                itemlist.usrnome = element.UsrNomeAd;
                                itemlist.usrramal = element.UsrRamal;


                                let itemOption = {}
                                itemOption.code = element.UsrCodigo;
                                itemOption.label = element.UsrNome;

                                this.atendentesList.push(itemlist);
                                this.atendentesOptions.push(itemOption);
                            });
                        }
                    }
                }
                xhr.open("GET", this.$apiUrl + "FaleConosco.svc/getatendentes");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send();
            },
            yesOrNoOptions: function () {
                const options = [
                    { code: 1, label: 'Sim', value: true },
                    { code: 2, label: 'Não', value: false }
                ];

                return options;
            },
            getSetores: function () {
                const options = [
                    { code: 1, label: 'Problemas de acesso ao site', value: "cadastro@aldo.com.br" },
                    { code: 2, label: 'Contas a Receber / Boletos', value: "recebimento@aldo.com.br" },
                    { code: 3, label: 'Comissão Venda Direta', value: "vendadireta@aldo.com.br" },
                    { code: 4, label: 'Vendas', value: "cartas@aldo.com.br" },
                    { code: 5, label: 'Faturamento', value: "cartas@aldo.com.br" },
                    { code: 6, label: 'Entrega / Transportadora', value: "cartas@aldo.com.br" },
                    { code: 7, label: 'RMA', value: "cartas@aldo.com.br" },
                    { code: 8, label: 'RH', value: "rh@aldo.com.br" },
                    { code: 9, label: 'Sugestões', value: "cartas@aldo.com.br" },
                    { code: 10, label: 'Geral', value: "cartas@aldo.com.br" },
                    { code: 11, label: 'Críticas / Reclamações', value: "cartas@aldo.com.br" },
                    { code: 12, label: 'Outras Dúvidas', value: "cartas@aldo.com.br" },
                ];

                return options;
            },
            enviarEmail: function () {
                var response = grecaptcha.getResponse();

                if (response.length == 0) {
                    //alert('nao verificado')
                    swal({
                        title: "Aviso",
                        text: "Por favor, selecione a opção evidenciando que você não é um robô.",
                        icon: "warning",
                        button: "OK"
                    })
                } else {
                    //alert('verificado')
                    var xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        if (xhr.status == 200) {
                            if (xhr.responseText != "" && xhr.responseText != null) {
                                let json = JSON.parse(xhr.responseText)
                                if (xhr.responseText.includes("sucesso")) {
                                    swal({
                                        title: "Notificação enviada com sucesso",
                                        icon: "success",
                                        button: "OK"
                                    })
                                }
                                else {
                                    swal({
                                        title: "Aviso",
                                        text: json,
                                        icon: "error",
                                        button: "OK"
                                    })
                                }
                            }
                        }
                    }
                    xhr.open("POST", this.$apiUrl + "FaleConosco.svc/enviaremail");
                    xhr.setRequestHeader("Content-Type", "application/json");
                    xhr.withCredentials = true;
                    xhr.send(JSON.stringify({
                        nome: this.frmContacUs.nome.value,
                        cnpj: this.frmContacUs.cnpj.value,
                        empresa: this.frmContacUs.empresa.value,
                        clienteAldo: this.frmContacUs.clienteAldo.value,
                        telefone: this.frmContacUs.telefone.value,
                        setor: this.frmContacUs.setor.value.label,
                        mensagem: this.frmContacUs.mensagem.value,
                        setorValue: this.frmContacUs.setor.value.value,
                        email: this.frmContacUs.email.value,
                        assunto: this.frmContacUs.assunto.value,
                    }));
                }
            }
        }
    };
</script>
